import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { resendVerificationEmail } from '@/services/memberAuth';

const inputClass =
  'w-full px-3.5 md:px-5 py-2.5 md:py-4 rounded-xl border border-[#E8E0D6] text-base outline-none focus:ring-2 focus:ring-[#1B3D2A]/15 focus:border-[#1B3D2A]';

export default function ResendVerification() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (!email.trim()) {
      setError('請輸入 Email。');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await resendVerificationEmail(email.trim());
      setSent(true);
    } catch {
      setError('發送失敗，請稍後再試。');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <div className="mx-auto max-w-md px-6 py-12 md:py-20">
          <div className="mb-8 text-center">
            <span className="inline-block text-xs font-semibold tracking-widest text-[#D4A574] uppercase mb-2">
              Verify Email
            </span>
            <h1 className="text-2xl md:text-3xl font-bold text-[#1B3D2A]">補寄認證信</h1>
          </div>

          {sent ? (
            <div className="rounded-2xl border border-[#E8E0D6] bg-[#FAF8F5] p-6 md:p-8 text-center">
              <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[#1B3D2A]/10">
                <i className="ri-mail-check-line text-2xl text-[#1B3D2A]" />
              </div>
              <p className="text-sm leading-relaxed text-[#5A6B5A]">
                若 <span className="font-bold text-[#1B3D2A]">{email}</span> 尚未完成驗證，我們已重新寄出驗證信，請至信箱查收。
              </p>
              <button
                type="button"
                onClick={() => navigate('/login')}
                className="mt-6 rounded-xl bg-[#1B3D2A] px-6 py-3 text-sm font-bold text-white hover:bg-[#143026]"
              >
                返回登入
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4 rounded-2xl border border-[#E8E0D6] bg-[#FAF8F5] p-6 md:p-8">
              <p className="text-sm text-[#5A6B5A]">若您註冊時未收到驗證信，或驗證連結已逾期，請輸入註冊時使用的 Email 重新發送。</p>
              <div>
                <label htmlFor="resend-email" className="block text-sm font-medium text-[#1B3D2A] mb-1.5">Email</label>
                <input
                  id="resend-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="name@example.com"
                  className={inputClass}
                />
              </div>

              {error && <div className="rounded-xl bg-[#fdebea] px-4 py-3 text-sm text-[#c3423f]">{error}</div>}

              <button
                type="submit"
                disabled={submitting}
                className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#1B3D2A] py-3.5 text-base font-bold text-white transition-colors hover:bg-[#143026] disabled:opacity-60"
              >
                {submitting ? '發送中...' : '重新發送驗證信'}
              </button>
            </form>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
